import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png"

const SampleApprovalListViewFull = (props) => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

    const todayDate = format(new Date(), "yyyy-MM-dd");

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    const userAccessGroup = currentUserObject[0].accessgrp;

    const initialFilterObject = {
        fromDate: "1900-01-01",
        toDate: todayDate,
        task_creator_id:
            userAccessGroup?.trim().toUpperCase() == "COORDINATOR"
                ? empIDFromUserObjectInLocalStorage
                : "-",
        task_owner_id:
            userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
                userAccessGroup?.trim().toUpperCase() != "ADMIN"
                ? empIDFromUserObjectInLocalStorage
                : "-",
        free_text: "-",
    };

    const [showLeadFilter, setShowLeadFilter] = useState(false);
    const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [quotationList, setQuotationList] = useState(null);
    const [quotationDetailsData, setQuotationDetailsData] = useState(null);
    const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (currentPageNumber) {
            console.log("currentPageNumber ", currentPageNumber);

            const currentUserDepartment = localStorage.getItem(
                "currentSelectedDepartment"
            );
            const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
            const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

            if (!currentUserObject) {
                console.error("No user data found in localStorage");
                return;
            }

            const userAccessGroup = currentUserObject[0].accessgrp;

            console.log("currentUserDepartment:", currentUserDepartment);
            console.log("userAccessGroup:", userAccessGroup);

            fetchQuotationList(
                userAccessGroup,
                currentUserDepartment,
                initialFilterObject,
                empIDFromUserObjectInLocalStorage
            );
        }
    }, [currentPageNumber]);

    const fetchQuotationList = (
        userAccessGroup,
        currentUserDepartment,
        filterObjectFromModal,
        empIDFromUserObjectInLocalStorage
    ) => {

        console.log("filterObjectFrom Modal", filterObjectFromModal)

        setLoading(true);

        try {
            let url = "";

            if (userAccessGroup?.trim().toUpperCase() === "ADMIN" || userAccessGroup?.trim().toUpperCase() === "CADMIN" || userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" || userAccessGroup?.trim().toUpperCase() === "C ACC JUNIOR") {
                url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/SAMPLEAPPROVAL/-/${currentUserDepartment}`
            }

            axios.get(url).then((res) => {
                console.log("Quotation List:", res.data);
                setQuotationList(res.data);
            });
        } catch (error) {
            console.error("Error fetching quotations:", error);
        } finally {
            setLoading(false);
        }
    };



    const giveBackStageStyle = (stage) => {
        switch (stage) {
            case "Approved":
                return "inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset";

            case "For Approval":
                return "inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset";

            case "Draft":
                return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";

            default:
                return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";
        }
    };


    const applyFilters = () => { };

    useEffect(() => {
        const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
        const userAccessGroup = currentUserObject[0].accessgrp;
        setCurrentUserGroupAccess(userAccessGroup);
    }, []);

    const callAPIToChangeStatus = (quot_slNo, statusByAdmin) => {

        const currentUserDepartment = localStorage.getItem(
            "currentSelectedDepartment"
        );

        const currentUserfromLocalStorage = JSON.parse(
            localStorage.getItem("currentUser")
        );

        let currentUserEMPID = "-";

        if (currentUserfromLocalStorage) {
            console.log(
                "currentUserfromLocalStorage[0] ",
                currentUserfromLocalStorage[0]
            );
            currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
        } else {
            console.log(
                "currentUserfromLocalStorage[0] else",
                currentUserfromLocalStorage[0]
            );
        }


        const jsonObject = [{
            CmpCode: company_code_from_local_storage,
            mode: "SAMPLEAPPROVAL",
            DocNo: quot_slNo,
            deptno:currentUserDepartment,
            Status: statusByAdmin,
            Comments: "",
            UserID: currentUserEMPID?.trim(),
            created_on: format(new Date(), "yyyy-MM-dd"),

        }]

        const jsonToSend = JSON.stringify(jsonObject);

        const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;

        axios.post(apiUrl, jsonToSend, {
            headers: {
                "Content-Type": "application/json",
            },
        }).then((res) => {

            if (res.data.result == "Saved") {

                alert("Saved")




            } else {
                alert("Something went wrong")
            }


        }).catch((err) => {

        })
    }

    //   const goToAdminSalesOrderDetails = (clickedListItem) => {


    //     // let selectedLead = {
    //     //   ...clickedListItem,
    //     //   lead_id: clickedListItem.Lead_ID,
    //     //   lead_organization: clickedListItem.Customer,
    //     //   lead_account: clickedListItem.Account,
    //     //   lead_salesperson: clickedListItem.Sales_Person,
    //     //   lead_coordinator: clickedListItem.Coordinator,
    //     //   deptno: clickedListItem.Dept
    //     // }
    //     // console.log("selectedLead>>> Admin List", selectedLead)

    //     // navigate(`/sales_order_details_admin`, { state: { selectedLead } })

    //     callAPIToChangeStatus()

    //   }


    const goToUserSalesOrderDetails = (clickedListItem) => {


        let selectedLead = {
            ...clickedListItem,
            lead_id: clickedListItem.Lead_ID,
            lead_organization: clickedListItem.Customer,
            lead_coordinator: clickedListItem.Coordinator,
            lead_salesperson: clickedListItem.Sales_Person,
            lead_account: clickedListItem.Account,
            deptno: clickedListItem.Dept
        }
        console.log("selectedLead>>>", selectedLead)

        navigate('/sales_order_details_user', { state: { selectedLead } })
    }





    return (
        <div className="min-h-screen px-6">
            <div className="flex justify-between items-center mb-4 ">
                {quotationDetailsPopup && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="bg-white rounded-lg p-6 max-w-[30%] w-full shadow-lg relative">
                            <h2 className="text-lg font-semibold mb-4">Quotation Details</h2>

                            {quotationDetailsData?.map((detail, index) =>
                                console.log("detail::", detail)
                            )}
                            {/* {quotationDetailsData?.map((detail,index)=> */}
                            {
                                quotationDetailsData.length > 0 && (
                                    <div className="space-y-3  max-h-[400px] max-w-[500px]   overflow-y-auto scrollbar-hide">
                                        <div className="p-4">
                                            <p>
                                                <strong>Quotation Number:</strong>{" "}
                                                {quotationDetailsData[0].so_no}
                                            </p>
                                            <p>
                                                <strong>Date:</strong> {quotationDetailsData[0].so_date}
                                            </p>
                                            <p>
                                                <strong>Revision Number:</strong>{" "}
                                                {quotationDetailsData[0].jv_num}
                                            </p>
                                            <p>
                                                <strong>Customer Name:</strong>{" "}
                                                {quotationDetailsData[0].accdesc}
                                            </p>
                                            <p>
                                                <strong>Customer Account:</strong>{" "}
                                                {quotationDetailsData[0].cust_acc}
                                            </p>
                                            <p>
                                                <strong>Amount:</strong>{" "}
                                                {quotationDetailsData[0].so_amount}
                                            </p>
                                            <p>
                                                <strong>Salesperson:</strong>{" "}
                                                {quotationDetailsData[0].sale_man}
                                            </p>
                                            <p>
                                                <strong>Department No:</strong>{" "}
                                                {quotationDetailsData[0].deptno}
                                            </p>
                                            <p>
                                                <strong>Status:</strong>{" "}
                                                {quotationDetailsData[0].so_status}
                                            </p>
                                        </div>

                                        {quotationDetailsData?.map((detail, index) => (
                                            <div className="border rounded-md p-4">
                                                <p>items{detail.length}</p>
                                                <p>
                                                    <strong>Item Code:</strong> {detail?.so_icode}
                                                </p>
                                                <p>
                                                    <strong>Item Description:</strong> {detail?.idesc}
                                                </p>
                                            </div>
                                        ))}


                                    </div>
                                )
                                // ) : (
                                //   <p className="text-gray-500">No data available</p>
                                // )
                            }

                            {/* Close Button */}
                            <button
                                onClick={() => setQuotationDetailsPopup(false)}
                                className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}

                <h3 className="text-xl font-normal text-gray-800 ">Sample Request List</h3>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <button style={{ display: "flex", alignItems: "center" }} onClick={() => setShowLeadFilter((prev) => !prev)}>
          <img style={{ width: "15px", height: "15px" }} src={ic_filter} />
          Filter
        </button>{" "} */}
                {currentPageNumber != 1 && (
                    <button
                        className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                        onClick={() =>
                            setCurrentPageNumber((prev) => (prev - 1 >= 1 ? prev - 1 : 1))
                        }
                    >
                        Previous
                    </button>
                )}
                <button
                    onClick={() => setCurrentPageNumber((prev) => prev + 1)}
                    className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                    style={{ marginLeft: "10px" }}
                >
                    Next
                </button>{" "}
            </div>

            <div className="bg-white rounded-lg shadow-sm">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-200 text-gray-600 text-sm">
                            <th className="p-1">Quotation Number</th>
                            <th className="p-1">Date</th>
                            <th className="p-1">LPO No.</th>
                            <th className="p-1">Customer Name</th>
                            <th className="p-1">Customer Account</th>
                            <th className="p-1">Code</th>
                            <th className="p-1">Description</th>
                            <th className="p-1">Salesperson</th>
                            <th className="p-1">Sample Qty</th>
                            <th className="p-1">Status</th>
                            <th className="p-1 text-center w-[240px]">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quotationList?.map((list, index) => (
                            <tr key={index} className="border-b text-sm hover:bg-gray-50">
                                <td className="p-1">{list.Proposal_No}</td>
                                {/* <td className="p-1 ">{list.so_date}</td> */}
                                <td className="p-1">
                                    {dayjs(list.Date).format("DD/MM/YYYY")}
                                </td>
                                <td className="p-1">{list.so_ref}</td>
                                <td className="p-1">{list.Customer?.trim()}</td>
                                <td className="p-1">{list.Cust_Acc}</td>
                                <td className="p-1">{list.Code}</td>
                                <td className="p-1">{list.Description}</td>
                                <td className="p-1">{list.Salesperson?.trim()}</td>
                                <td className="p-1">{list.Sample_Qty}</td>
                
                                <td className="p-1">
                                    <span className={giveBackStageStyle(list.Status)}>
                                        {list.Status}
                                    </span>
                                </td>
                                <td className="p-1 ">
                                    <div className="flex justify-between items-center gap-1">

                                        {
                                            <div>
                                                <button
                                                    className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                                    // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                                                    onClick={() => callAPIToChangeStatus(list.quot_slNo, "Approved")}
                                                >
                                                    Approve
                                                </button>

                                                <button
                                                    className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                                    // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                                                    onClick={() => callAPIToChangeStatus(list.quot_slNo, "Rejected")}
                                                >
                                                    Reject
                                                </button>
                                            </div>


                                        }




                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {loading ? (
                <p className="inset-0 fixed flex justify-center items-center">
                    Loading quotations... <CircularProgress size={24} />
                </p> // Show loader while fetching
            ) : (
                <ul>
                    {/* {quotationList?.map((quote, index) => (
            <li key={index}>{quote.name}</li>
          ))} */}
                </ul>
            )}

            {showLeadFilter && (
                <QuotationListFilterModal
                    applyFilters={applyFilters}
                    closeFilter={() => setShowLeadFilter(false)}
                    fetchQuotationList={fetchQuotationList}
                />
            )}
        </div>
    );
};

export default SampleApprovalListViewFull;
